"use strict";
exports.__esModule = true;
var tslib_1 = require("tslib");
var client_1 = require("@apollo/client");
var error_1 = require("@apollo/client/link/error");
function createAuthenticatedHttpLink(options) {
    if (options === void 0) { options = {}; }
    if (!options.uri)
        throw new Error('Missing uri option');
    return client_1.ApolloLink.from([
        new client_1.ApolloLink(function (operation, forward) {
            var token = window.localStorage.getItem('auth:token');
            operation.setContext({
                headers: tslib_1.__assign(tslib_1.__assign({}, operation.getContext().headers), (token ? { authorization: "Bearer " + token } : {}))
            });
            return forward(operation);
        }),
        error_1.onError(function (_a) {
            var networkError = _a.networkError;
            if (networkError && 'statusCode' in networkError && networkError.statusCode === 401) {
                window.localStorage.removeItem('auth:token');
                window.location.reload();
            }
        }),
        client_1.createHttpLink(options),
    ]);
}
exports["default"] = createAuthenticatedHttpLink;
//# sourceMappingURL=createAuthenticatedHttpLink.js.map